<template>
  <div class="">

    <div class="experts">
      <div>
        <!-- <b-carousel
          fade
          indicators
          img-width="1024"
          img-height="480"
        > -->
        <!-- <b-carousel-slide class="d-flex align-items-center h-100 " img-blank> -->
        <div class="experts-div"> <!-- -->
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="header">
              <div class="section-header">
                <div class="description">
                  <h2>{{ langDec.experts_section_h2 }}</h2>
                  <p>
                    <b>{{ langDec.experts_section_bold }}</b>
                    <br><br>
                    {{ langDec.experts_section_p }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="pageIsLoading && !items.length" class="expert-cards-loading text-center py-5">
          <b-spinner variant="primary" :label="langDec.experts_loading_label" />
          <p class="mt-3 mb-0 text-muted">{{ langDec.experts_loading_text }}</p>
        </div>

        <!-- شبكة + ترقيم صفحات (صفحة /experts) -->
        <template v-else-if="layout === 'grid'">
          <div v-if="!items.length" class="text-center text-muted py-5 mb-0">
            {{ langDec.experts_grid_empty }}
          </div>
          <div v-else class="expert-grid-wrap">
            <div class="row expert-cards-row justify-content-start">
              <div
                v-for="item in items"
                :key="item.id"
                class="col-12 col-sm-6 col-lg-3 mb-4 expert-cards-col"
              >
                <div
                  class="transBox expert-card expert-card--clickable"
                  role="button"
                  tabindex="0"
                  @click="goToDoctor(item.id)"
                  @keyup.enter="goToDoctor(item.id)"
                >
                  <div class="transBox-icon">
                    <img
                      class="gridSection-img expert-card__avatar"
                      :src="photoSrc(item)"
                      :alt="(item.firstName || '') + ' ' + (item.lastName || '')"
                    />
                  </div>
                  <div class="transBox-text expert-card__body">
                    <div>
                      <h5 class="expert-card__name">
                        {{ item.firstName + ' ' + item.lastName }}
                      </h5>
                      <p class="description expert-card__desc">
                        <span v-if="line1(item)">
                          {{ line1(item) }}
                          <br>
                        </span>
                        <span v-if="line2(item)">{{ line2(item) }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="totalCount > gridPerPage" class="my-3 expert-grid-pagination">
              <b-pagination
                v-model="pageNumber"
                :per-page="gridPerPage"
                :total-rows="totalCount"
                align="center"
                size="sm"
                @change="onGridPageChanged"
              />
            </div>
          </div>
        </template>

        <!-- سلايدر (الصفحة الرئيسية وغيرها) -->
        <div v-else class="expert-swiper-wrap">
          <div ref="expertSwiper" class="swiper expert-swiper">
            <div class="swiper-wrapper">
              <div
                v-for="item in items"
                :key="item.id"
                class="swiper-slide expert-swiper-slide"
              >
                <div
                  class="transBox expert-card expert-card--clickable"
                  role="button"
                  tabindex="0"
                  @click="goToDoctor(item.id)"
                  @keyup.enter="goToDoctor(item.id)"
                >
                  <div class="transBox-icon">
                    <img
                      class="gridSection-img expert-card__avatar"
                      :src="photoSrc(item)"
                      :alt="(item.firstName || '') + ' ' + (item.lastName || '')"
                    />
                  </div>
                  <div class="transBox-text expert-card__body">
                    <div>
                      <h5 class="expert-card__name">
                        {{ item.firstName + ' ' + item.lastName }}
                      </h5>
                      <p class="description expert-card__desc">
                        <span v-if="line1(item)">
                          {{ line1(item) }}
                          <br>
                        </span>
                        <span v-if="line2(item)">{{ line2(item) }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination expert-swiper-pagination"></div>
          </div>
        </div>
        </div>
        <!-- </b-carousel-slide> -->
        <!-- </b-carousel> -->
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import { sendRequest } from '../utils/RequestHelper.js'
import { mapGetters } from 'vuex'
export default {
  name: 'ExpertCarousel',
  props: {
    pageSize: {
      type: Number,
      default: null,
    },
    fetchAll: {
      type: Boolean,
      default: false,
    },
    /** swiper: سلايدر تلقائي | grid: بطاقات مع ترقيم صفحات */
    layout: {
      type: String,
      default: 'swiper',
      validator: (v) => v === 'swiper' || v === 'grid',
    },
  },
  data() {
    return {
      pageIsLoading: true,
      items: [],
      pageNumber: 1,
      totalCount: 0,
      expertSwiper: null,
    }
  },
  computed: {
    ...mapGetters(['getLangData']),
    langDec() {
      return this.getLangData || {}
    },
    gridPerPage() {
      if (this.layout !== 'grid') return 12
      const raw = this.pageSize
      if (raw != null && raw !== '') {
        const n = Number(raw)
        if (Number.isFinite(n) && n > 0) return n
      }
      return 12
    },
  },
  watch: {
    '$store.state.lang'() {
      if (this.layout !== 'swiper') return
      this.$nextTick(() => this.syncExpertSwiper())
    },
    items() {
      if (this.layout !== 'swiper') {
        this.destroyExpertSwiper()
        return
      }
      this.$nextTick(() => this.syncExpertSwiper())
    },
  },
  methods: {
    isRtl() {
      if (typeof document === 'undefined') return false
      const de = document.documentElement
      const dir = de.getAttribute('dir') || document.body.getAttribute('dir') || ''
      return dir.toLowerCase() === 'rtl'
    },
    syncExpertSwiper() {
      if (this.layout !== 'swiper') {
        this.destroyExpertSwiper()
        return
      }
      if (!this.items.length) {
        this.destroyExpertSwiper()
        return
      }
      this.destroyExpertSwiper()
      const el = this.$refs.expertSwiper
      if (!el) return
      const paginationEl = el.querySelector('.expert-swiper-pagination')
      if (!paginationEl) return
      this.expertSwiper = new Swiper(el, {
        modules: [Autoplay, Pagination],
        rtl: this.isRtl(),
        /* كسور لعرض جزء من الشريحة قبل/بعد — يوضح أن القائمة قابلة للتحريك */
        slidesPerView: 1.22,
        spaceBetween: 14,
        centeredSlides: true,
        grabCursor: true,
        speed: 650,
        rewind: true,
        autoplay: {
          delay: 4200,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 5,
        },
        breakpoints: {
          576: {
            slidesPerView: 1.65,
            spaceBetween: 16,
            centeredSlides: true,
          },
          768: {
            slidesPerView: 2.35,
            spaceBetween: 18,
            centeredSlides: true,
          },
          992: {
            slidesPerView: 3.35,
            spaceBetween: 20,
            centeredSlides: true,
          },
          1200: {
            slidesPerView: 3.65,
            spaceBetween: 22,
            centeredSlides: true,
          },
        },
      })
    },
    destroyExpertSwiper() {
      if (this.expertSwiper) {
        this.expertSwiper.destroy(true, true)
        this.expertSwiper = null
      }
    },
    goToDoctor(id) {
      if (!id) return
      this.$router.push({
        name: 'expertProfile',
        params: { id: String(id) },
      })
    },
    apiBatchSize() {
      if (this.pageSize != null && this.pageSize !== '') {
        const n = Number(this.pageSize)
        return Number.isFinite(n) && n > 0 ? n : this.fetchAll ? 20 : 4
      }
      return this.fetchAll ? 20 : 4
    },
    photoSrc(item) {
      const path = item && item.imageUrl
      if (!path) {
        return (
          'data:image/svg+xml,' +
          encodeURIComponent(
            '<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120"><circle fill="#e8f0eb" cx="60" cy="60" r="60"/><text x="60" y="72" text-anchor="middle" fill="#006633" font-size="28">👤</text></svg>'
          )
        )
      }
      if (/^https?:\/\//i.test(path)) return path
      return 'https://api.takhatty.com/' + String(path).replace(/^\//, '')
    },
    line1(item) {
      const jobs = (item && item.jobDegrees) || []
      const specs = (item && item.specializations) || []
      if (jobs.length && specs.length) {
        return `${jobs[0].name} في ${specs[0].name}`
      }
      if (specs.length) return specs[0].name
      if (jobs.length) return jobs[0].name
      return ''
    },
    line2(item) {
      const degs = (item && item.scientificDegrees) || []
      if (!degs.length) return ''
      let s = `${this.langDec.experts_degree_prefix || 'حاصل على'} ${degs[0].name}`
      if (item.universityName) s += ` ${this.langDec.experts_degree_from || 'من'} ${item.universityName}`
      return s
    },
    loadData() {
      const batchSize =
        this.layout === 'grid'
          ? this.gridPerPage
          : this.apiBatchSize()
      this.pageIsLoading = true

      if (this.layout === 'grid') {
        sendRequest(
          'post',
          'Doctors/',
          true,
          {
            userRole: 'Provider',
            pageNumber: this.pageNumber,
            pageSize: batchSize,
          },
          (response) => {
            const data = response.data.data || {}
            this.items = data.items || []
            this.totalCount =
              data.totalCount != null ? data.totalCount : this.items.length
            this.pageIsLoading = false
          },
          () => {
            this.pageIsLoading = false
            this.items = []
            this.totalCount = 0
          }
        )
        return
      }

      if (!this.fetchAll) {
        sendRequest(
          'post',
          'Doctors/',
          true,
          {
            userRole: 'Provider',
            pageNumber: 1,
            pageSize: batchSize,
          },
          (response) => {
            this.items = (response.data.data && response.data.data.items) || []
            this.totalCount =
              (response.data.data && response.data.data.totalCount) ||
              this.items.length
            this.pageIsLoading = false
          },
          () => {
            this.pageIsLoading = false
            this.alertType = 'danger'
            this.alertText = 'Error loading data'
          }
        )
        return
      }

      const merged = []
      const maxPages = 60
      const fetchPage = (pageNum) => {
        sendRequest(
          'post',
          'Doctors/',
          true,
          {
            userRole: 'Provider',
            pageNumber: pageNum,
            pageSize: batchSize,
          },
          (response) => {
            const data = response.data.data || {}
            const batch = data.items || []
            const total = data.totalCount != null ? data.totalCount : 0
            merged.push(...batch)
            const shortPage = batch.length < batchSize
            const reachedTotal = total > 0 && merged.length >= total
            if (
              shortPage ||
              reachedTotal ||
              pageNum >= maxPages ||
              !batch.length
            ) {
              this.items = merged
              this.totalCount = total > 0 ? total : merged.length
              this.pageIsLoading = false
            } else {
              fetchPage(pageNum + 1)
            }
          },
          () => {
            this.pageIsLoading = false
            this.alertType = 'danger'
            this.alertText = 'Error loading data'
          }
        )
      }
      fetchPage(1)
    },
    onGridPageChanged() {
      if (this.layout !== 'grid') return
      this.loadData()
    },
  },
  created() {
    this.loadData();
  },
  beforeDestroy() {
    this.destroyExpertSwiper()
  },
}
</script>

<style scoped>
.experts {
  display: flex;
  justify-content: center;
  padding: 16px 12px;
}

@media (min-width: 576px) {
  .experts {
    padding: 20px 24px;
  }
}

@media (min-width: 992px) {
  .experts {
    padding: 20px 48px;
  }
}

@media (min-width: 1400px) {
  .experts {
    padding: 20px 100px;
  }
}

.experts-div {
  width: 100%;
  max-width: 1320px;
  margin-left: auto;
  margin-right: auto;
}

.expert-cards-loading {
  width: 100%;
}

.expert-swiper-wrap {
  padding-bottom: 2.75rem;
  /* يمدّد المنطقة المرئية قليلاً حتى يبان مقطع الشريحة الجانبية أوضح */
  margin-left: -0.75rem;
  margin-right: -0.75rem;
  width: calc(100% + 1.5rem);
}

@media (max-width: 767.98px) {
  .expert-swiper-wrap {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .expert-swiper-wrap {
    margin-left: -1rem;
    margin-right: -1rem;
    width: calc(100% + 2rem);
  }
}

.expert-swiper {
  width: 100%;
  overflow: hidden;
  padding-bottom: 2.25rem;
}

.expert-swiper-slide {
  height: auto;
  box-sizing: border-box;
}

.expert-swiper-slide > .expert-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 100%;
  padding: 1.35rem 1rem 1.5rem;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(0, 102, 51, 0.12);
  box-shadow: 0 6px 22px rgba(0, 38, 19, 0.07);
}

.expert-swiper :deep(.swiper-pagination) {
  bottom: 0;
}

.expert-swiper :deep(.swiper-pagination-bullet) {
  width: 8px;
  height: 8px;
  background: #006633;
  opacity: 0.35;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.expert-swiper :deep(.swiper-pagination-bullet-active) {
  opacity: 1;
  transform: scale(1.15);
}

.expert-card__avatar {
  object-fit: cover;
}

.expert-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
}

/* experts */
.experts .transBox img {
  border-radius: 500%;
  width: 120px !important;
  height: 120px !important;
}

.experts .transBox-text {
  color: black !important;
  box-shadow: unset !important;
  justify-content: center;
}

.experts .section-header {
  color: black !important;
  display: flex;
  justify-self: center;
  width: 100%;
  justify-content: center;
}

h2 {
  text-align: center;
  color: black !important;
  font-weight: bold;
  margin-bottom: 20px;
}

.transBox-icon {
  display: flex;
  justify-content: center;
}

.experts .carousel-item {
  bottom: 50% !important;
  text-align: center;
}

.expert-card--clickable {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.expert-card--clickable:hover,
.expert-card--clickable:focus {
  transform: translateY(-4px);
  border-color: rgba(0, 102, 51, 0.28);
  box-shadow: 0 14px 36px rgba(0, 102, 51, 0.14);
  outline: none;
}

.experts .expert-card .expert-card__name {
  text-align: center;
  margin-bottom: 0.65rem;
  margin-top: 1rem;
  cursor: pointer;
  font-weight: 700;
  line-height: 1.35;
  font-size: 1.05rem;
}

.experts .expert-card .expert-card__desc {
  text-align: center;
  margin-bottom: 0 !important;
  padding: 0.35rem 6px 0 !important;
  font-size: 0.95rem;
  line-height: 1.55;
}

.experts .description {
  color: grey;
  font-size: 17px;
  text-align: center;
  padding: 5px 10px;
  margin-bottom: 40px;
}

.experts .description b {
  color: rgb(26, 26, 26);
  font-size: 20px;
}

.gridSection-img {
  width: 120px;
}

.expert-grid-wrap {
  width: 100%;
}

.expert-cards-row {
  margin-top: 0.25rem;
}

.expert-cards-col {
  display: flex;
}

.expert-cards-col > .expert-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 100%;
  padding: 1.35rem 1rem 1.5rem;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(0, 102, 51, 0.12);
  box-shadow: 0 6px 22px rgba(0, 38, 19, 0.07);
}

.expert-grid-pagination {
  width: 100%;
}

@media (max-width: 991.98px) {

  .experts {
    padding-top: unset !important;
  }

}

@media (max-width: 767.98px) {
  .experts {
    padding: 20px 10px !important;
  }
}
</style>